import React from "react"
import "./Premiumresidences.css"

const PremiumResidences = () => {
  return (
    <div>
      <div className="swisspremiumresidency" data-aos="fade-up"
        data-aos-duration="1000">
        <div className="swisspremiumresidency-top">
          <h3>PREMIUM RESIDENCES</h3>
        </div>
        <div className="swisspremiumresidency-bottom">
          <div>
            <img src="./DowntownPhotos/PremiumResidences/premium1.jpg" alt="" className="swisspremiumresidency-bottom-img" />
            <img src="./DowntownPhotos/PremiumResidences/hover1.jpg" alt="" className="swisspremiumresidency-bottom-hover-img" />
            <p>1 Bed Room</p>
          </div>
          <div>
            <img src="./DowntownPhotos/PremiumResidences/premium2.jpg" alt="" className="swisspremiumresidency-bottom-img swisspremiumresidency-bottom-2img" />
            <img src="./DowntownPhotos/PremiumResidences/hover2.jpg" alt="" className="swisspremiumresidency-bottom-hover-img" />
            <p>2 Bed Room</p>
          </div>
          <div>
            <img src="./DowntownPhotos/PremiumResidences/premium3.jpg" alt="" className="swisspremiumresidency-bottom-img" />
            <img src="./DowntownPhotos/PremiumResidences/hover3.jpg" alt="" className="swisspremiumresidency-bottom-hover-img" />
            <p>3 Bed Room</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PremiumResidences
